import { connect } from 'react-redux';
import { userLogout } from 'redux/actions/layoutActions';
import UserProfile from './UserProfile';

const mapStateToProps = ({ layout }) => {
    const { userData } = layout;
    return { userData };
};

const mapDispatchToProps = { userLogout };

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
